<template>
  <Modal
    :mask-closable="false"
    v-model="visable"
    class-name="vertical-center-modal"
    width="900"
    title="系统通知"
    footer-hide
  >
  <spinner :transparency="0.1" v-model="loading"></spinner>
  <div :style="{  height: '500px', overflowY: 'auto' }">
        
       <Form
            ref="userForm"
            :model="userForm"
            :label-width="100"
          > 
            <FormItem label="发件人：" prop="sendUserName" style="margin-bottom: 12px;">
              {{userForm.sendUserName}}
            </FormItem>
            <FormItem label="通知类型：" prop="noticeTypeText" style="margin-bottom: 12px;">
              {{userForm.noticeTypeText}}
            </FormItem>
            <FormItem label="标题：" prop="noticeTitle" style="margin-bottom: 12px;">
              {{userForm.noticeTitle}}
            </FormItem>
            <FormItem label="通知内容：" prop="noticeContent" style="margin-bottom: 12px;">
              <Editor
                  :valueMutil="userForm.noticeContent"
                  :height="300"
                  :readonly="readonly"
                  v-if="visable"
                />
            </FormItem>
            <FormItem style="text-align: right;margin-bottom: 12px;">
                <Button @click="visable =false">关闭</Button>
                <Button type="primary" @click="selectNoReadMessageList()" v-if="nextVisable == true">下一条</Button>
            </FormItem>
          </Form> 

  </div>
  </Modal>
</template>
<script>
import Editor from "~/components/RichText/Editor";
export default {
  name:"noticeMessageView",
  components: {
    Editor
  },
  data() {
    return {
        userForm:{},
        loading: false,
        readonly:true,
        visable:false,
        noticeTypeList:[],
        dataList:[],
        nextVisable:false,

    };
  },
  mounted() {
  },
  methods: {

    show() {
      if( this.visable ==false){
        // this.getNoticeType();
        this.selectNoReadMessageList()
      }else{
        this.selectNoReadMessageCount()
      }
        
    },
    getNoticeType(){
      this.$store
          .dispatch("noticeOnline/selectNoticeType", {})
          .then(res => {
            this.noticeTypeList = res
          })
          .catch(error => {

          });
    },
    changeReadStatus(id) {
      this.$store
        .dispatch("noticeOnline/updateReadStatus", { id: id })
        .then(res => {
          this.selectNoReadMessageCount()
        });
    },
    selectNoReadMessageCount(){
      this.$store
          .dispatch("noticeOnline/selectNoReadMessageCount", {})
          .then(res => {
            if(res >0){
              this.nextVisable = true
            }else {
              this.nextVisable = false
            }
          })
          .catch(error => {

          });
    },
    selectNoReadMessageList() {
      this.$store
        .dispatch("noticeOnline/selectNoReadMessageList")
        .then(res => {
            if(res && res.length>0){
              this.userForm = res[0]
              this.changeReadStatus(res[0].id)
              this.$nextTick(()=>{
                this.visable = true
              })
            } 
        });
    },
  },

};
</script>

<style lang="less" scoped>
/deep/.ivu-modal .ivu-select-dropdown {
  z-index: 1000;
}

.messageList {
  height: 60%;
  /deep/.el-scrollbar__wrap {
    overflow-x: hidden;
   
  }
}
/deep/ .ck.ck-editor__top.ck-reset_all{
display: none;
}
</style>


